import { combineReducers } from "redux";
import loginReducer from "../containers/Login/loginReducer";
import rolesReducer from "../containers/Login/rolesReducer";
import userProfileReducer from "../containers/Login/userProfileReducer";
import commonReducer from "./commonReducer";
import candidateListingReducer from "../containers/CandidateListing/candidateListingReducer";
import responseManagerReducer from "../containers/ResponseManager/responseManagerReducer";
import jobPostingReducer from "../containers/JobPosting/jobPostingReducer";
import snackbarReducer from "../components/Snackbar/snackbarReducer";
import homeReducer from "../containers/Home/homeReducer";
import dashboardReducer from "../containers/Dashboard/dashboardReducer";
import faqReducer from "../containers/Faq/faqReducer";
import documentVerificationReducer from "../containers/DocumentVerification/documentVerificationReducer";
import profileReducer from "../containers/Profile/profileReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const authPersistConfig = {
  key: "metaData",
  storage: storage,
  whitelist: ["city", "metaDataVersion"]
};

const appReducer = combineReducers({
  commonReducer,
  loginReducer,
  rolesReducer,
  userProfileReducer,
  candidateListingReducer,
  jobPostingReducer: persistReducer(authPersistConfig, jobPostingReducer),
  snackbarReducer,
  homeReducer,
  responseManagerReducer,
  dashboardReducer,
  faqReducer,
  documentVerificationReducer,
  profileReducer
});

const reducer = (state, action) => {
  if (action.type === "RESET_APPLICATION_STATE") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default reducer;
